import path from 'path'
import type { HandleDelete } from '@payloadcms/plugin-cloud-storage/types'
import { APIError } from 'payload'
import { getFetchURL } from '../utils'
import { wlodevS3Path } from '../config'

export const getHandleDelete = (): HandleDelete => {
    return async ({ doc, req, collection }) => {
        try {
            const url = getFetchURL(req.headers, path.posix.join(wlodevS3Path))
            url.searchParams.set('key', doc.filename)
            url.searchParams.set('collection', collection.slug)

            const res = await fetch(url, {
                method: 'DELETE',
                headers: {
                    cookie: req.headers.get('cookie') ?? '',
                },
            })
            if (!res.ok) {
                throw new APIError(
                    `Request to to delete file failed: ${doc.filename} from wlodev storage`
                )
            }
        } catch (error) {
            throw new APIError(
                `Failed to delete file: ${doc.filename} from wlodev storage`
            )
        }

        return
    }
}
